'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _CountdownTimer = require('components/Common/CountdownTimer');

var _CountdownTimer2 = _interopRequireDefault(_CountdownTimer);

var _analytics = require('redux/modules/analytics');

var analyticsAction = _interopRequireWildcard(_analytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FirebasePhoneAuth = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, analyticsAction)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FirebasePhoneAuth, _Component);

  function FirebasePhoneAuth(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, FirebasePhoneAuth);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FirebasePhoneAuth.__proto__ || (0, _getPrototypeOf2.default)(FirebasePhoneAuth)).call(this, props));

    _this.onChangePhoneNumber = function (event) {
      _this.setState({ phoneNumber: event.target.value });
    };

    _this.onChangePhonePrefix = function (event) {
      _this.setState({ phonePrefix: event.target.value });
    };

    _this.onChangeVerificationCode = function (event) {
      var lenghtValue = event.target.value.length;
      if (lenghtValue <= 6) {
        _this.setState({ verificationCode: event.target.value });
        if (lenghtValue === 6) {
          if (!_this.state.allowConfirm) {
            _this.setState({ allowConfirm: true });
          }
        } else {
          if (_this.state.allowConfirm) {
            _this.setState({ allowConfirm: false });
          }
        }
      }
    };

    _this.recordTracking = function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { error: '' },
          error = _ref.error;

      var _this$state = _this.state,
          phoneNumber = _this$state.phoneNumber,
          phonePrefix = _this$state.phonePrefix;
      var _this$props = _this.props,
          isBooking = _this$props.isBooking,
          desktopMode = _this$props.desktopMode;

      _this.props.submitAnalyticsAction({
        actionName: !isBooking ? 'login_firebase' : 'booking_login_firebase',
        origin: desktopMode ? 'web' : 'mobile-web',
        originURL: '',
        phoneNumber: phonePrefix + phoneNumber,
        platform: navigator.userAgent,
        error: error || ''
      });
    };

    _this.onSubmit = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var _this$state2, phoneNumber, phonePrefix, verificationCode, isEnterCode;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state2 = _this.state, phoneNumber = _this$state2.phoneNumber, phonePrefix = _this$state2.phonePrefix, verificationCode = _this$state2.verificationCode;
              isEnterCode = _this.props.isEnterCode;

              if (isEnterCode) {
                _context.next = 10;
                break;
              }

              if (!_this.checkPhoneNumber(phoneNumber)) {
                _context.next = 7;
                break;
              }

              _this.recordTracking();
              _this.props.onVerifyPhone(phonePrefix, phoneNumber);
              return _context.abrupt('return');

            case 7:
              alert('Số điện thoại không đúng. Vui lòng nhập lại số điện thoại');
              _context.next = 12;
              break;

            case 10:
              _this.setState({ submitCode: true });
              _this.props.onSubmitCode(verificationCode);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.checkPhoneNumber = function (phone) {
      var vnfRegex = /(0?(9|3|7|8|5)+([0-9]{8})\b)/g;
      var phoneTester = new RegExp(vnfRegex);
      return phoneTester.test(phone);
    };

    _this.state = {
      phonePrefix: '+84',
      phoneNumber: props.phone || '',
      verificationCode: '',
      allowConfirm: false
    };
    return _this;
  }

  (0, _createClass3.default)(FirebasePhoneAuth, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!!this.props.phone && !!nextProps.phone && nextProps.phone !== this.props.phone) {
        this.setState({ phoneNumber: nextProps.phone });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./FirebasePhoneAuth.scss');
      var _props = this.props,
          desktopMode = _props.desktopMode,
          show = _props.show,
          isEnterCode = _props.isEnterCode,
          isSendingError = _props.isSendingError,
          isSendingSMS = _props.isSendingSMS;
      var _state = this.state,
          phonePrefix = _state.phonePrefix,
          phoneNumber = _state.phoneNumber,
          verificationCode = _state.verificationCode,
          allowConfirm = _state.allowConfirm;

      var mainClass = 'modalLookme modal';
      if (desktopMode) {
        mainClass = 'modalLookme firebaseDesktop modal';
      }
      var phoneTitle = !isEnterCode ? 'Vui lòng nhập số điện thoại' : 'Vui lòng nhập mã xác nhận';
      var confirmBtn = isEnterCode ? 'Xác nhận' : 'Gửi SMS';
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          show: show,
          bsClass: mainClass,
          centered: true,
          dialogClassName: styles.firebaseDesktopMode
        },
        _react2.default.createElement(
          'div',
          { className: styles.firebaseBtnClose },
          !isEnterCode && _react2.default.createElement('i', {
            className: 'fa fa-close ' + styles.closeIcon,
            onClick: this.props.onHide
          }),
          _react2.default.createElement(
            'span',
            { className: styles.modalHeaderText },
            '\u0110\u0103ng nh\u1EADp b\u1EB1ng s\u1ED1 \u0111i\u1EC7n tho\u1EA1i'
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(
            'div',
            { className: styles.firebasePhoneContainer },
            _react2.default.createElement(
              'p',
              { className: styles.phoneTitle },
              phoneTitle
            ),
            _react2.default.createElement(
              'span',
              { className: 'form-group ' + styles.inputContainer },
              !isEnterCode && _react2.default.createElement('input', {
                type: 'text',
                value: phonePrefix,
                onChange: this.onChangePhonePrefix,
                className: 'form-control ' + styles.input + ' ' + styles.inputPrefix
              }),
              !isEnterCode && _react2.default.createElement('input', {
                autoFocus: true,
                type: 'number',
                value: phoneNumber,
                onChange: this.onChangePhoneNumber,
                className: 'form-control ' + styles.input + ' ' + styles.inputPhone
              }),
              isEnterCode && _react2.default.createElement('input', {
                autoFocus: true,
                type: 'number',
                value: verificationCode,
                onChange: this.onChangeVerificationCode,
                className: 'form-control ' + styles.input + ' ' + styles.inputCode
              })
            ),
            !isEnterCode && _react2.default.createElement('div', {
              id: 'recaptcha-container',
              className: styles.recaptchaContainer
            }),
            isEnterCode && _react2.default.createElement(
              'div',
              { className: styles.noneCode },
              _react2.default.createElement(
                'span',
                null,
                'M\xE3 code s\u1EBD \u0111\u01B0\u1EE3c g\u1EEDi trong '
              ),
              _react2.default.createElement(_CountdownTimer2.default, {
                noWrapper: !!true,
                className: styles.countDown,
                seconds: 30,
                textRight: ' giây',
                onDone: function onDone() {
                  _this3.recordTracking({
                    error: 'Người dùng này đã chờ 30s nhưng không nhập code.'
                  });
                  if (confirm('Bạn đã nhận được code chưa bạn có cần sự trợ giúp của Lookme?')) {
                    window.open('https://m.me/lookmevietnam', '_blank');
                  }
                }
              })
            ),
            !isEnterCode && _react2.default.createElement(
              'button',
              {
                className: 'btn ' + styles.confirmBtn + ' ' + (!!(isSendingError || isSendingSMS) ? styles.loginTooMany : ''),
                onClick: !(isSendingError || isSendingSMS) ? this.onSubmit : null
              },
              confirmBtn
            ),
            isEnterCode && _react2.default.createElement(
              'button',
              {
                className: 'btn ' + styles.confirmBtn + ' ' + (!allowConfirm ? styles.loginTooMany : ''),
                onClick: allowConfirm ? this.onSubmit : null
              },
              confirmBtn
            )
          )
        )
      );
    }
  }]);
  return FirebasePhoneAuth;
}(_react.Component), _class2.propTypes = {
  desktopMode: _propTypes2.default.bool,
  show: _propTypes2.default.bool,
  phone: _propTypes2.default.string,
  onHide: _propTypes2.default.func.isRequired,
  onVerifyPhone: _propTypes2.default.func.isRequired,
  onSubmitCode: _propTypes2.default.func.isRequired,
  isEnterCode: _propTypes2.default.bool.isRequired,
  isBooking: _propTypes2.default.bool,
  isSendingError: _propTypes2.default.bool,
  isSendingSMS: _propTypes2.default.bool,

  submitAnalyticsAction: _propTypes2.default.func.isRequired
}, _temp)) || _class);
exports.default = FirebasePhoneAuth;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Auth/FirebasePhoneAuth.js
// module id = 1530
// module chunks = 0